import React, { useState } from 'react';
import { useAlerts } from '../../Hooks/useAlerts';
import PageHeader from '../../Components/common/PageHeader';
import AlertTable from '../../Components/criticalAlertsAndInsights/AlertTable';
import AlertSummaryCards from '../../Components/criticalAlertsAndInsights/AlertSummaryCards';
import InsightsCard from '../../Components/criticalAlertsAndInsights/InsightsCard';
import AlertConfigCard from '../../Components/criticalAlertsAndInsights/AlertConfigCard';
import AlertDetailModal from '../../Components/criticalAlertsAndInsights/AlertDetailModal';
import AlertRulesModal from '../../Components/criticalAlertsAndInsights/AlertRulesModal';

const CriticalAlertsAndInsights = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterStatus, setFilterStatus] = useState('Todos los Estados');
  const [filterLevel, setFilterLevel] = useState('Todos los Niveles');
  const [selectedAlert, setSelectedAlert] = useState(null);
  // `null` = cerrado. Con código, el modal abre directo en ese detector, que
  // es lo que espera quien pulsó "Configurar" en una tarjeta concreta.
  const [configCode, setConfigCode] = useState(null);
  const [isConfigOpen, setIsConfigOpen] = useState(false);

  const {
    alerts,
    pagination,
    summary,
    insights,
    insightsLoading,
    insightsError,
    isLoading,
    error,
    updateStatus,
    isUpdatingStatus,
    runEngine,
    isRunning,
    runError,
  } = useAlerts({
    page: currentPage,
    limit: pageSize,
    level: filterLevel,
    status: filterStatus,
    search: debouncedSearch,
  });

  const handleSearch = (event) => {
    if (event.key === 'Enter') {
      setDebouncedSearch(searchTerm);
      setCurrentPage(1);
    }
  };

  const changeFilter = (setter) => (event) => {
    setter(event.target.value);
    setCurrentPage(1);
  };

  const openConfig = (code = null) => {
    setConfigCode(code);
    setIsConfigOpen(true);
  };

  return (
    <>
      <PageHeader
        title="Alertas críticas e insights"
        crumbs={[{ label: 'General' }, { label: 'Alertas' }]}
        actions={
          <button
            type="button"
            className="ui-btn"
            onClick={runEngine}
            disabled={isRunning}
            title="Vuelve a evaluar todas las reglas activas"
          >
            <i className={isRunning ? 'ri-loader-4-line' : 'ri-refresh-line'} />
            {isRunning ? 'Evaluando...' : 'Actualizar alertas'}
          </button>
        }
      />

      {summary?.last_run_at && (
        <div className="ui-hint" style={{ marginTop: -12, marginBottom: 16 }}>
          Última evaluación:{' '}
          {new Date(summary.last_run_at).toLocaleString('es-CO', {
            timeZone: 'America/Bogota',
          })}
        </div>
      )}

      {runError && (
        <div className="ui-note ui-note--danger mb-3">{runError.message}</div>
      )}
      {error && (
        <div className="ui-note ui-note--danger mb-3">{error.message}</div>
      )}

      <AlertSummaryCards summary={summary} />

      <div className="ui-grid-main">
        <AlertTable
          alerts={alerts}
          pagination={pagination}
          isLoading={isLoading}
          filterLevel={filterLevel}
          filterStatus={filterStatus}
          searchTerm={searchTerm}
          onFilterLevelChange={changeFilter(setFilterLevel)}
          onFilterStatusChange={changeFilter(setFilterStatus)}
          onSearchChange={(e) => setSearchTerm(e.target.value)}
          onSearchEnter={handleSearch}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          updateStatus={updateStatus}
          isUpdatingStatus={isUpdatingStatus}
          onViewAlert={setSelectedAlert}
        />

        <div>
          <AlertConfigCard onOpenConfig={openConfig} />
          <InsightsCard
            insights={insights}
            isLoading={insightsLoading}
            error={insightsError}
          />
        </div>
      </div>

      <AlertDetailModal
        isOpen={Boolean(selectedAlert)}
        toggle={() => setSelectedAlert(null)}
        alert={selectedAlert}
        onMarkAsResolved={(alertId) => updateStatus(alertId, 'Resuelta')}
      />

      <AlertRulesModal
        isOpen={isConfigOpen}
        toggle={() => setIsConfigOpen(false)}
        initialCode={configCode}
      />
    </>
  );
};

export default CriticalAlertsAndInsights;
